import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import React from "react";
import { ToastContainer } from "react-toastify";
import { CedarShellLayout } from "../../components/Layouts";
import { TORCH_RED } from "../../constants";
import { CollapsibleFaqTile } from "./components/CollapsibleFaqTile";
import { FaqAccordion } from "./components/FaqAccordion";
import { GlossaryTileContent } from "./components/GlossaryTileContent";
import { GoogleConnectTileContent } from "./components/GoogleConnectTileContent";
import { HandbookTileContent } from "./components/HandbookTileContent";
import { UserGuideTileContent } from "./components/UserGuideTileContent";
import "../../assets/styles/pages/faqPage.scss";

export const FaqPage = () => (
  <CedarShellLayout>
    <div className="faq_page" data-test-id="faq-page">
      <div className="faq_page_header">
        <HelpOutlineIcon className="page_header_icon" />
        <div>
          <h1 className="faq_page_title">FAQ</h1>
          <p className="faq_page_subtitle">Guides, connection help and FAQs for CEDAR Home.</p>
        </div>
      </div>

      <CollapsibleFaqTile
        icon={<MenuBookOutlinedIcon style={{ color: TORCH_RED }} />}
        title="CEDAR Home User Guide"
        description="Full walkthrough of platform features, dashboards and best practices."
      >
        <UserGuideTileContent />
      </CollapsibleFaqTile>

      <CollapsibleFaqTile
        icon={<DescriptionOutlinedIcon style={{ color: TORCH_RED }} />}
        title="Nissan Data & Insights Glossary"
        description="Official glossary of KPIs, metrics and terminology used across CEDAR dashboards."
      >
        <GlossaryTileContent />
      </CollapsibleFaqTile>

      <CollapsibleFaqTile
        icon={<MenuBookOutlinedIcon style={{ color: TORCH_RED }} />}
        title="G-M&S Handbook"
        description="Global Marketing & Sales Re:Ignite Control Handbook"
      >
        <HandbookTileContent />
      </CollapsibleFaqTile>

      <CollapsibleFaqTile
        icon={<LinkOutlinedIcon style={{ color: TORCH_RED }} />}
        title="How to Connect Nissan ID to Google"
        description="Link your Nissan ID with your Google account for single sign-on"
      >
        <GoogleConnectTileContent />
      </CollapsibleFaqTile>

      <CollapsibleFaqTile
        icon={<HelpOutlineIcon style={{ color: TORCH_RED }} />}
        title="FAQs"
        description="Common questions and troubleshooting"
      >
        <FaqAccordion />
      </CollapsibleFaqTile>

      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick={true}
        draggable={false}
        pauseOnHover={false}
      />
    </div>
  </CedarShellLayout>
);
